import { Action } from '@/_core/fluxstore/types';
import { uuid } from '@/_core/utils/uuid';
import { Activity, StorymapState } from '../../types';
import { getActiveCard, GetNewEmptyActivity } from '../../use';
import { useStorymapStore } from '../../useModule';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:addNewActivity');

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddNewActivity extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddNewActivity';

    public _cardId: string = null;
    public constructor(public order: number, public willBeSavedImmediately: boolean = false) {
        super(AddNewActivity.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddNewActivity): Promise<boolean> => {
    debug('AddNewActivity.middleware', action);
    action._cardId = await uuid.create();
    return true;
};

const reducer = (state: StorymapState, action: AddNewActivity): void => {
    debug('AddNewActivity.reducer', action);

    const activeCard = getActiveCard();

    state.activities.filter((x) => x.order >= action.order).forEach((x) => x.order++);

    const activity: Activity = GetNewEmptyActivity({
        id: action._cardId,
        color: state.activityColor,
        order: action.order,
        isNew: action.willBeSavedImmediately ? false : true,
        isActive: true,
        isSaving: action.willBeSavedImmediately ? true : false,
        createdByUserId: initAppData.currentUser.currentUserShortId,
    });

    state.activities.push(activity);

    // Track newly created card for visibility in hide-unfiltered mode
    if (state.filterState.hideUnfiltered) {
        state.filterState.newlyCreatedCardIds.push(activity.id);
    }

    if (activeCard) {
        activeCard.isActive = false;
    }

    return;
};

//@ts-ignore
registerMiddleware(AddNewActivity.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddNewActivity.ACTION_TYPE, reducer);
